import { IntlProvider } from "use-intl";
import Footer from "./Footer";
import StoreProvider from "./store/provider";
import { FC, useEffect, useState } from "react";
import { State } from "./store/type";
import { Languages, LanguagesType } from "../types";
import { initialState } from "./store/context";
import { FooterProps } from "./types";
import { listenerUpdateGlobalTheme } from "../common/CustomEvent";
import { BUITheme } from "@blofin/blofin-ui";
import { UserInfo } from "../Header/types";

const FooterWrapper: FC<FooterProps> = ({
  theme,
  baseUrl,
  footerBgColor,
  isSimple = false,
  env,
  size
}) => {
  const [state, setState] = useState<State>({
    ...initialState,
    theme: theme,
    baseUrl: baseUrl || "",
    env: env
  });

  useEffect(() => {
    listenerUpdateGlobalTheme((theme: BUITheme) => {
      setState((state) => ({
        ...state,
        theme: theme
      }));
    });

    let attempts = 0;
    const maxAttempts = 20;

    const timer = setInterval(() => {
      if (window.userInfo) {
        const userInfo = window.userInfo as UserInfo;
        setState((state) => ({
          ...state,
          userInfo: userInfo,
          isLogin: userInfo?.uid ? true : false
        }));
        clearInterval(timer);
      } else if (++attempts >= maxAttempts) {
        clearInterval(timer);
        console.warn("Failed to get userInfo after maximum attempts");
      }
    }, 200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // 会触发更新
  useEffect(() => {
    const locale = window?.next?.router?.state?.locale || "en";

    setState((state) => ({
      ...state,
      theme: theme,
      locale: locale as LanguagesType,
      localeLink: locale === "en" ? "" : "/" + locale
    }));
  }, [theme]);

  return (
    <StoreProvider value={state}>
      <IntlProvider locale={state.locale} messages={Languages[state.locale as LanguagesType]}>
        <Footer footerBgColor={footerBgColor} isSimple={isSimple} size={size} />
      </IntlProvider>
    </StoreProvider>
  );
};

export default FooterWrapper;
